import http from './http';

export interface IGetRoomList {
  pageNum: number;
  pageSize: number;
  checkStatus?: 1 | 2 | null; // 1-待查房 2-已查房 null或不传返回全部
}

export interface IComputerList {
  computerId: bigint;
  displayName: string;
  id?: bigint;
  itemId: bigint;
  lastReportTime: string;
  manualCheck: 1 | 2 | null;
  no: bigint;
  selfCheck: 1 | 2 | 3 | 4 | null; // 硬件自动检测【1尚未得到上报记录 2硬件自动校验正常 3检测到硬件异常 4自动检测超时】
}

export interface IGoodsList {
  consumeQty: number;
  id?: bigint;
  itemId: bigint;
  lastRemainQty: number;
  remainQty: number;
  skuCode: string;
  skuName: string;
  spuId: bigint;
  spuName: string;
  price: number;
}

export interface ISaveInventoryParams {
  checkStatus: 1 | 2 | null; // 查房状态(1待查房，2已查房)
  computerList: IComputerList;
  goodsList: IGoodsList;
  peripheralList: any[];
  id?: bigint;
  resvNo: string; // 归属订单号
}

// 获取门店下机器硬件信息列表
export const getCheckRoomRecordList = (data: IGetRoomList) => {
  return http({
    url: '/check-room/list',
    method: 'POST',
    data,
  });
};

// 查房抽屉&查房结果抽屉
export const getInventoryDetail = (id: bigint) => {
  return http({
    url: `/check-room/detail/${id}`,
    method: 'GET',
  });
};

// 确认查房完毕
export const saveInventoryResult = (data: ISaveInventoryParams) => {
  return http({
    url: '/check-room/save',
    method: 'POST',
    data,
  });
};

// 获取查房列表
export const getRoomInventoryRecordList = (data) => {
  return http({
    url: '/check-room/v2/list',
    method: 'POST',
    data,
  });
};
